import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
	root: {
		'&:hover, &$active': {
			outline: `2px solid ${theme.palette.scoreapp.primary}`,
			outlineOffset: ({ outlineOffset }) => outlineOffset,
		},
	},
	active: {
		outlineOffset: ({ outlineOffset }) => outlineOffset,
	},
}))

export default useStyles
